import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CssBaseline, Grid, makeStyles, Paper } from '@material-ui/core';
import clsx from 'clsx';
import moment from 'moment';

import Gis from '../gis/Gis';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { TransitionCurve } from '../charts/TransitionCurve';
import {GisInformation} from '../tables/gisInformation/GisInformation'
import { GisInformationAlarmsTable } from '../tables/gisInformation/GisInformationAlarmsTable';
import { SelectPoints } from '../ui/SelectPoints';
import { ScrollTop } from '../ui/ScrollTop';
import HistoricFilters from './historicFilters/HistoricFilters';





const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        overflowX: 'hidden',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingLeft: theme.spacing(4),
    },
    paper: {
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 550,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
    fixedHeightTables: {
        height: 210,
        overflowY: 'hidden',
        overflowX: 'hidden',
    },
}));

export const HistoricScreen = () => {
    const [dashboardReference, setDashboardReference] = useState();
    const [filters, setFilters] = useState({
        pointName: '',
        startDate: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm'),
        endDate: moment().format('YYYY-MM-DD HH:mm'),
        today: moment().format('YYYY-MM-DD HH:mm'),
        initialDay: moment('2021-01-01').format('YYYY-MM-DD HH:mm'),
    });
    const [filterMins, setFilterMins] = useState({
        pointName: '',
    });

    const [getDataToggle, setGetDataToggle] = useState(false);
    const [hasLoadedData, setHasLoadedData] = useState(false);

    const { width } = useWindowDimensions();

    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const fixedHeightPaperTables = clsx(classes.paper, classes.fixedHeightTables);

    const isMobile = width <= 768;

    //validation for users
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        if (getDataToggle) {
            setGetDataToggle(false);
        }
    }, [getDataToggle]);

    const handleChange = (fieldName, newValue) => {
        setFilters((currentFilters) => ({ ...currentFilters, [fieldName]: newValue }));
    };

    const handleChangeMins = (fieldName, newValue) => {
        setFilterMins((currentFilters) => ({ ...currentFilters, [fieldName]: newValue }));
    };

    return (
        <>
            <CssBaseline />
            <main
                className={classes.content}
                ref={(node) => {
                    if (node) {
                        setDashboardReference(node);
                    }
                }}
            >
                <div className={classes.appBarSpacer} id="GIS" />

                <Grid container spacing={3} className={classes.container}>
                    <Grid item xs={12}>
                        <HistoricFilters
                            applyFilters={() => {
                                setGetDataToggle(true);
                                if (!hasLoadedData) {
                                    setHasLoadedData(true);
                                }
                            }}
                            filters={filters}
                            handleChange={handleChange}
                        />
                    </Grid>
                    {hasLoadedData && (
                        <>
                            {/* GIS COMPONENT */}
                            <Grid item container spacing={3} xs={12}>
                                <Grid item xs={12} md={6} lg={9}>
                                    {isMobile && 
                                        <GisInformation
                                            filters={filters} 
                                            realtime={false}
                                            getDataToggle={getDataToggle}  
                                        />
                                    }
                                    <Paper className={fixedHeightPaper}>
                                        <Gis getDataToggle={getDataToggle} filters={filters} realtime={false} />
                                    </Paper>
                                </Grid>

                              

                                <Grid item xs={12} md={6} lg={3}>
                                    <Grid container spacing={3}>
                                        {!isMobile &&
                                            <Grid item xs={12}>
                                                <GisInformation 
                                                    filters={filters}
                                                    getDataToggle={getDataToggle}
                                                    realtime={false}
                                                />
                                            </Grid>
                                        }
                                        <Grid item xs={12}>
                                            <Paper className={fixedHeightPaperTables}>
                                                <GisInformationAlarmsTable 
                                                    filters={filters}
                                                    getDataToggle={getDataToggle}
                                                    realtime={false}
                                                />
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* CHART COMPONENT */}
                            {auth.valitadion.ceHistoric === 'True' &&
                                <Grid item container spacing={3} xs={12} md={12} lg={12}>
                                    
                                    <Grid item xs={12} md={12} lg={12}>
                                        <SelectPoints 
                                            filters={filterMins}
                                            handleChange={handleChangeMins}
                                            requestName={'nombreSCE'}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={12}>
                                        <Paper className={classes.paper}>
                                            <TransitionCurve
                                                filters={filters}
                                                getDataToggle={getDataToggle}
                                                realtime={false}
                                                namePoint={filterMins.pointName}
                                                historic={true}
                                            />
                                        </Paper>
                                    </Grid>
                                    
                                </Grid>
                            }

                        </>
                    )}
                </Grid>

                <ScrollTop dashboardReference={dashboardReference} />
            </main>
        </>
    );
};
